import type { PlanFeature } from '../planFeature';
import { t } from 'src/i18n';

export const planFeatures: PlanFeature[] = [
  {
    value: 'templates',
    post: 8118,
    name: t('features.planFeatures.templates'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'hms',
    post: 10545,
    name: t('features.planFeatures.hms'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'privacy',
    post: 8147,
    name: t('features.planFeatures.privacy'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'issues',
    post: 8317,
    name: t('features.planFeatures.issues'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'calendar',
    post: 8153,
    name: t('features.planFeatures.calendar'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'meetings',
    post: 8284,
    name: t('features.planFeatures.meetings'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'roles',
    post: 8233,
    name: t('features.planFeatures.roles'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'staffing',
    post: 8249,
    name: t('features.planFeatures.staffing'),
    plans: ['A', 'B', 'C'],
  },
  {
    value: 'assets',
    post: 8273,
    name: t('features.planFeatures.assets'),
    plans: ['B', 'C'],
  },
  {
    value: 'substanceRegister',
    post: 10291,
    name: t('features.planFeatures.substanceRegister'),
    plans: ['B', 'C'],
  },
  {
    value: 'followUp',
    post: 10582,
    name: t('features.planFeatures.followUp'),
    plans: ['C'],
  },
  {
    value: 'healthcare',
    post: 15429,
    name: t('features.planFeatures.healthcare'),
    plans: [''],
  },
];
